let pos_comp_Table = require("../../templates/pos/comp/Table.handlebars");
let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
import i18n from "../../utils/i18n";
import ValidationView from "../comp/ValidationView.js";
let PagingView = require("../comp/PagingView.js");
let PagingModel = require("../../model/PagingModel.js");
import POS from "../../POS.js";

let main = function () {
    return Backbone.View.extend({
        pageView: null,

        events: {
            'click .create': 'showModal',
            'click .modal .ok': 'createTable',
            'click .modal .delete': 'deleteTable',
            'click .aTable': 'showEditModal',
            'keyup .modal': 'keypressModal',
            'click .createQrcode': 'createQrcode'
        },

        render: function () {
            var viewHeight = $(window).height() - 80 - this.$('.header').height();
            this.pageView = new PagingView({
                el: this.$('.tableList'), pagingControl: this.$('.paging'),
                model: new PagingModel({
                    viewHeight: viewHeight,
                    rowSize: 4, rowHeight: viewHeight / 4, itemSize: this.$('.pitem').size()
                })
            });
            this.pageView.render();
            return this;
        },
        createQrcode: function (evt) {
            var qrCodeHref = window.location.origin, id = $(evt.currentTarget).data("id");
            qrCodeHref += "/restaurant/createTableQrcode/" + id;
            window.open(qrCodeHref);
        },
        createTable: function () {
            var validation = new ValidationView({el: this.$('#tableNameInput')}), id = this.$('.modal').data('data-id'),
                url = id ? '/api/table/edit/' + id : '/api/table/create',
                result, self = this;

            if (this.$('#tableNameInput').val().length > 20) {
                alert(i18n.msg("pos.setting.table.name.error"));
                this.$('#tableNameInput').focus();
                return;
            }

            if (!validation.notEmpty().isValid()) {
                validation.render();
                return;
            }
            POS.showLoading(true);
            result = $.post(url, {
                tableName: this.$('#tableNameInput').val(),
                multiple: this.$(".multiple-selector").val(),
                tableType: this.$('#tableTypeInput').val()
            });
            result.done(function (res) {
                if (res.success) {
                    console.log(res);
                    self.$('.aTable[data-id="' + id + '"]').remove();
                    var tableView = $(pos_comp_Table(res));
                    self.$(".tableList").prepend(tableView);
                    self.closeModal();
                    self.pageView.render();
                    self.trigger('needRefresh');

                } else {
                    self.$('.modal .form-group.tableNameInput').addClass('has-error').find('.help-block').text(res.error);
                }

            });

            result.error(function (res) {
                self.$('.modal .form-group.tableNameInput').addClass('.has-error').find('.help-block').text("!!!!");
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        deleteTable: function () {
            if (!confirm(i18n.msg('pos.setting.table.deleteMsg'))) {
                return;
            }

            var id = this.$('.modal').data('data-id'), result = $.post('/api/table/delete/' + id), self = this;
            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    self.$('.aTable[data-id="' + id + '"]').remove();
                    self.closeModal();
                    self.pageView.render();
                    self.trigger('needRefresh');
                }
            });

            result.fail(function (res) {

            });
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        showModal: function () {
            var modal = this.$('.modal');
            modal.find('.modal-content').addClass("settingsModal");
            this.$('#tableNameInput').val('');
            this.$('#tableTypeInput').val('');
            modal.find('.form-group').removeClass('has-error');
            modal.find('.help-block').text("");
            modal.find('.delete').addClass('hidden');
            if (modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').removeClass("saveEdit-btn");
            }
            if (!modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').addClass("saveCreate-btn");
            }
            modal.data('data-id', null).modal('show');
            modal.find('.modal-title').text(i18n.msg('pos.setting.table.newtable'));
        },

        showEditModal: function (evt) {
            var modal = this.$('.modal');
            modal.find('.modal-content').addClass('settingsModal');
            modal.find(".form-group").removeClass("has-error");
            modal.find('.help-block').text("");
            modal.find('.delete').removeClass('hidden');
            if (modal.find('.ok').hasClass("saveCreate-btn")) {
                modal.find('.ok').removeClass("saveCreate-btn");
            }
            if (!modal.find('.ok').hasClass("saveEdit-btn")) {
                modal.find('.ok').addClass("saveEdit-btn");
            }
            modal.find('.modal-title').text(i18n.msg('pos.setting.table.edittable'));
            var tableEle = $(evt.currentTarget),
                id = tableEle.data('id'),
                multiple = tableEle.find(".multiple-input").val(),
                code = tableEle.find(".type-input").val(),
                name = tableEle.find('.name').text();
            this.$('#tableNameInput').val(name);
            this.$('.multiple-selector').val(multiple);
            this.$('#tableTypeInput').val(code);
            modal.data('data-id', id).modal('show');
        },

        closeModal: function () {
            this.$('.modal').modal('hide');
        },

        keypressModal: function (evt) {
            if (evt.which == 13 && !this.$('.modal').data('data-id')) {
                this.createTable();
            }
        }

    });
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/settings/TableSettingView.js